"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  en: {
    reactMuiTables: {
      selected: 'selected',
      filterhide: 'Hide Filter',
      filtershow: 'Show Filter',
      refresh: 'Refresh',
      filter: {
        actions: {
          search: 'Search',
          resetFilter: 'Reset Filter',
          addCondition: 'Add Condition'
        }
      },
      standardOperators: {
        equals: 'equals',
        contains: 'contains',
        between: {
          label: 'between',
          from: 'from',
          to: 'to'
        },
        oneOf: 'one of'
      },
      labelRowsPerPage: 'Rows per page:'
    }
  }
};
var _default = messages;
exports.default = _default;